<template>
  <div>
    <q-dialog :visible="isVisible" title="查看银联冻结保证金" width="400px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="content-box">
        <div class="row">银联冻结保证金: {{ money }}</div>
        <div style="text-align: center; margin-top: 20px">
          <el-button @click="onCancel" size="medium">关 闭</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    isShowWalletDialog: {
      type: Boolean,
      default: false,
    },
    money: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.isShowWalletDialog;
      },
      set(val) {
        this.$emit("update:isShowWalletDialog", val);
      },
    },
  },
  data() {
    return {
     
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item {
  margin-bottom: 10px;
}
</style>
